import reactresources from "../../../../assets/img/programming/reactresources.webp";
import github from "../../../../assets/img/programming/github.webp";
import devhints from "../../../../assets/img/programming/devhints.webp";
import hero35 from "../../../../assets/img/programming/hero35.webp";
import reactiflux from "../../../../assets/img/programming/reactiflux.webp";
import reactypescript from "../../../../assets/img/programming/reactypescript.webp";
import react from "../../../../assets/img/programming/react.webp";
import scotch from "../../../../assets/img/programming/scotch.webp";
import codepen from "../../../../assets/img/programming/codepen.webp";
import reactrainbow from "../../../../assets/img/programming/reactrainbow.webp";
import bitdev from "../../../../assets/img/programming/bitdev.webp";
import freefrontend from "../../../../assets/img/programming/freefrontend.webp";
import reactlibraries from "../../../../assets/img/programming/reactlibraries.webp";
import reactsight from "../../../../assets/img/programming/reactsight.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";

export const DataDoc = [
  {
    title: "React Resources",
    path: "https://reactresources.com/articles",
    icon: reactresources,
    cName: "icon",
    description:
      "On React Resources you can discover new resources for most topics related to React, a JavaScript library for building user interfaces.",
  },
  {
    title: "Awesome React",
    path: "https://github.com/enaqx/awesome-react",
    icon: github,
    cName: "icon",
    description: "A collection of awesome things regarding React ecosystem.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "Devhints",
    path: "https://devhints.io/react",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "React (Official)",
    path: "https://reactjs.org/docs/getting-started.html",
    icon: react,
    cName: "icon",
    description: "The Official react documentation.",
  },
  {
    title: "Reactiflux",
    path: "https://www.reactiflux.com/",
    icon: reactiflux,
    cName: "icon",
    description:
      "We’re a chat community of 110,000+ React JS React JS, React Native React Native, Redux Redux, Jest Jest, Relay Relay and GraphQL GraphQL developers. We hold Q&A’s with Facebook Engineers Facebook Organization and other developers Reactiflux Developers in the community Reactiflux Discord. Come chat about tech related to React & JavaScript or ask for help!",
  },
  {
    title: "Hero35",
    path: "https://hero35.com/",
    icon: hero35,
    cName: "icon",
    description:
      "React Is Fiction. In this talk you’ll learn how to write React like its fiction and what you can gain by doing so.",
  },
  {
    title: "React Typescript",
    path: "https://react-typescript-cheatsheet.netlify.app/",
    icon: reactypescript,
    cName: "icon",
    description:
      "Cheatsheets for experienced React developers getting started with TypeScript.",
  },
  {
    title: "Scotch",
    path:
      "https://scotch.io/starters/react/getting-started-with-react-2019-edition?ref=home-start-here",
    icon: scotch,
    cName: "icon",
    description: "Article on React (2019 edition).",
  },
];

export const DataComponents = [
  {
    title: "Awesome React Components",
    path: "https://github.com/brillout/awesome-react-components",
    icon: github,
    cName: "icon",
    description: "Curated List of React Components & Libraries.",
  },
  {
    title: "CodePen",
    path: "https://codepen.io/topic/react/templates",
    icon: codepen,
    cName: "icon",
    description: "CodePen is a social development environment.",
  },
  {
    title: "React Rainbow",
    path: "https://react-rainbow.web.app/#/Components",
    icon: reactrainbow,
    cName: "icon",
    description:
      "React Rainbow is a collection of components that will reliably help you build your application in a snap. Give it a hack and let us know what you think.",
  },
  {
    title: "Bit Dev",
    path: "https://bit.dev/",
    icon: bitdev,
    cName: "icon",
    description:
      "Bit is a scalable and collaborative way to build and reuse components. It's everything you need from local development to cross-project integrations.",
  },
  {
    title: "Free Frontend",
    path: "https://freefrontend.com/react-code-examples/",
    icon: freefrontend,
    cName: "icon",
    description:
      "Free React code examples from codepen.io and github.io: buttons, modal windows, menu and other.",
  },
  {
    title: "React.js Examples",
    path: "https://reactjsexample.com/",
    icon: react,
    cName: "icon",
    description: "Big compilation of components ready to use.",
  },
];

export const DataLibrary = [
  {
    title: "React Libraries",
    path: "https://reactlibraries.com/",
    icon: reactlibraries,
    cName: "icon",
    description:
      "A community-curated database of the most popular and frequently updated React libraries.",
  },
];

export const DataTools = [
  {
    title: "React Developer Tools",
    path: "https://addons.mozilla.org/en-US/firefox/addon/react-devtools/",
    icon: react,
    cName: "icon",
    description:
      "React Developer Tools is a tool that allows you to inspect a React tree, including the component hierarchy, props, state, and more.",
  },
  {
    title: "React Sight",
    path: "https://www.reactsight.com/#header",
    icon: reactsight,
    cName: "icon",
    description: "Visualize your react applications.",
  },
  {
    title: "React Proto",
    path: "https://react-proto.github.io/react-proto/",
    icon: react,
    cName: "icon",
    description:
      "React prototyping for designers and developers, it generate jsx file.",
  },
];
